import iubb from '@reolink/web.ubbcode';
import type { IParseToHtmlOptions } from '@reolink/web.ubbcode/dist/common';

import { customHandleUbbText } from '../ubb-utils';
function initGlobalEffect(): void {
    try {
        if (!iubb.getTagInfo()['icon']) {

            // 增加自定义icon图标
            iubb.addTag('icon', {
                switch: true,
                iterable: false,
                parse: (innerText: string) => {
                    // reo-ubb-icon为特定类名，用于业务上定制样式
                    return `<span class="${innerText} reo-ubb-icon"}"></span>`;
                },
                parseToUbb: (innerText: string) => {
                    return  `[icon]${innerText}[/icon]`;
                }
            }, false);
        }
        if (!iubb.getTagInfo()['img']) {

            // 增加增加自定义img标签
            iubb.addTag('img', {
                switch: true,
                iterable: false,
                parse: (innerText: string) => {
                    return `<img alt src="${innerText}" class="reo-ubb-img" />`;
                },
                parseToUbb: (innerText: string) => {
                    return  `[img]${innerText}[/img]`;
                }
            }, false);

        }
        if (!iubb.getTagInfo()['youtube']) {

            // 增加自定义youtube标签
            iubb.addTag('youtube', {
                switch: true,
                iterable: false,
                parse: (innerText: string) => {
                    return `<div class='mul-youtube-player-container reo-ubb-youtube'>
                        <iframe style="max-width:100%" title="embedded youtube video" data-src="${innerText}" width="650" height="365.625" src="${innerText}" frameborder="0" allowfullscreen></iframe>
                        </div>`;
                },
                parseToUbb: (innerText: string) => {
                    return  `[youtube]${innerText}[/youtube]`;
                }
            }, false);
        }

        if (!iubb.getTagInfo()['fontsize']) {
            iubb.addTag('fontsize', {
                switch: true,
                iterable: false,
                parse: (innerText: string, attribute: { originInput?: string; }) => {
                    if (!attribute.originInput) {
                        return innerText;
                    }
                    // eslint-disable-next-line prefer-const
                    let [sizePc, sizeM, lineHeightPc, lineHeightM] = attribute.originInput.slice(1).split(',');

                    if (!sizeM) {
                        sizeM = sizePc;
                    }

                    if (!lineHeightPc) {
                        lineHeightPc = '1.5';
                    }

                    if (!lineHeightM) {
                        lineHeightM = lineHeightPc;
                    }

                    const sizePcNum = Math.floor(Number(sizePc));
                    const sizeMNum = Math.floor(Number(sizeM));
                    const lineHeightPcNum = Math.floor(sizePcNum * Number(lineHeightPc));
                    const lineHeightMNum = Math.floor(sizeMNum * Number(lineHeightM));

                    return `
                    <span>
                        <style>
                            @media (min-width: 1000px){
                                .__reo_ubb_font-size-pc-${sizePcNum}_${lineHeightPcNum}_{
                                    display: inline-block;
                                    font-size: ${sizePcNum}px !important;
                                    line-height: ${ lineHeightPcNum }px!important;
                                }
                            }
                            @media (max-width: 999px){
                                .__reo_ubb_font-size-m-${sizeMNum}_${lineHeightMNum}_{
                                    display: inline-block;
                                    font-size: ${sizeMNum}px !important;
                                     line-height:  ${ lineHeightMNum }px!important;
                                }
                            }
                        </style>
                        <span class="__reo_ubb_font-size-pc-${sizePcNum}_${lineHeightPcNum}_ __reo_ubb_font-size-m-${sizeMNum}_${lineHeightMNum}_ ">{INNER_TEXT}</span>
                    </span>`.replace(/[\r\n]+/g, '').replace('{INNER_TEXT}', innerText)
                    ;

                },
                parseToUbb: (innerText: string, attribute: { originInput?: string; }) => {
                    return  `[fontsize${attribute.originInput ?? ''}]${innerText}[/fontsize]`;
                }
            }, false);
        }

    }
    catch (e) {
        console.warn('init ubb tag error', e);
    }
}

initGlobalEffect();

function replaceLastDiv(str: string): string {

    const target = '</div>';
    
    const lastMatchIndex = str.lastIndexOf(target);

    if (lastMatchIndex !== -1) {
        
        // 从最后一个匹配的位置开始截取，去掉最后一个 </div>
        const beforeLastDiv = str.substring(0, lastMatchIndex);
        // 获取最后一个 </div> 后面的内容
        const afterLastDiv = str.substring(lastMatchIndex + target.length);
        
        // 返回替换后的字符串
        return beforeLastDiv + afterLastDiv;
    }
    
    // 如果没有找到 </div>，直接返回原字符串
    return str;
}

export default function handleUbbTextWithV2(text: string|undefined, options: IParseToHtmlOptions): string {
    if (!text) {
        return '';
    }
    const t = replaceLastDiv(iubb.parseToHtmlV2(text?.replace(/<br\s*\/?>/g, '\n'), options)).replace('<div class="ubbContent">', '');
    const customT = customHandleUbbText(t);
    return customT;
}
